<template>
    <v-card class="mb-3">
        <v-card-title class="text-h6">
            <v-icon left color="primary">mdi-cash-multiple</v-icon>
            Buste Paga
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('prev-year')" title="Anno precedente"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <span class="text-subtitle-1 font-weight-bold mx-2">{{ year }}</span>
            <v-btn icon @click="$emit('next-year')" title="Anno successivo"><v-icon>mdi-chevron-right</v-icon></v-btn>
            <v-btn color="primary" small class="ml-4" @click="$emit('new-import')">
                <v-icon left small>mdi-file-import</v-icon>
                Nuovo import mensile
            </v-btn>
        </v-card-title>

        <v-card-text>
            <div class="months-strip">
                <div
                    v-for="m in summary"
                    :key="m.month"
                    class="month-cell"
                    :class="{ active: selectedMonth === m.month }"
                    @click="$emit('select-month', m.month)">
                    <div class="month-name">{{ monthName(m.month) }}</div>
                    <div class="month-count">{{ m.count }} {{ m.count === 1 ? 'cedolino' : 'cedolini' }}</div>
                    <div class="month-total">{{ formatCurrency(m.total_net) }}</div>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'hr-payslips-year-strip',
    props: {
        year: { type: Number, required: true },
        summary: { type: Array, default: () => [] },
        selectedMonth: { type: Number, default: null },
    },

    methods: {
        monthName(m) {
            const names = ['', 'Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre']
            return names[m] || ''
        },
        formatCurrency(v) {
            return v != null ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(parseFloat(v) || 0) : '—'
        },
    },
}
</script>

<style scoped>
.months-strip {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 4px;
}
.month-cell {
    cursor: pointer;
    padding: 8px 6px;
    border-radius: 6px;
    text-align: center;
    border: 1px solid #e0e0e0;
    transition: all 0.15s ease;
    background: #fafafa;
}
.month-cell:hover {
    background: #f0f0f0;
    border-color: #bdbdbd;
}
.month-cell.active {
    background: #fff3e0;
    border-color: #ffc107;
}
.month-name {
    font-size: 11px;
    font-weight: 600;
    color: #555;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.month-count {
    font-size: 11px;
    color: #888;
    margin-top: 2px;
}
.month-total {
    font-size: 13px;
    font-weight: 700;
    color: #333;
    margin-top: 2px;
}
@media (max-width: 900px) {
    .months-strip {
        grid-template-columns: repeat(4, 1fr);
    }
}
</style>
